import { render, staticRenderFns } from "./HomeCooperate.vue?vue&type=template&id=0208c376&scoped=true&"
import script from "./HomeCooperate.vue?vue&type=script&lang=js&"
export * from "./HomeCooperate.vue?vue&type=script&lang=js&"
import style0 from "./HomeCooperate.vue?vue&type=style&index=0&id=0208c376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208c376",
  null
  
)

export default component.exports